/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Grid } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import * as yup from 'yup'

export default function AccountSettings() {

  const formSchema1 = yup.object().shape({
    name: yup.string().required('El campo es requerido').max(8, 'El nombre no debe tener más de 40 caracteres'),

  })

  const formSchema2 = yup.object().shape({
    current_password: yup.string().required('El campo es requerido').min(8, 'La contraseña debe tener al menos 8 caracteres'),
    password: yup.string().required('El campo es requerido').min(8, 'La contraseña debe tener al menos 8 caracteres'),
    password_confirmation: yup.string().required('El campo es requerido').oneOf([yup.ref('password')], 'La contraseña no coincide'),
  })

  const { handleSubmit: handleSubmit1, control: control1, formState: { errors: errors1, isSubmitting: isSubmitting1 }, setValue } = useForm({ resolver: yupResolver(formSchema1), });
  const { handleSubmit: handleSubmit2, control: control2, formState: { errors: errors2, isSubmitting: isSubmitting2 } } = useForm({ resolver: yupResolver(formSchema2), });


  const onSubmit1 = (data) => {
    console.log(data)
  }

  const onSubmit2 = (data) => {
    console.log(data)
  }


  return (
    <MDBox >
      <MDBox pb={3}>
        <Card sx={{ boxShadow: "none" }} >
          <MDBox p={3} component="form" role="form" onSubmit={handleSubmit1(onSubmit1)}>
            <MDBox pb={2}>
              <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                Información Básica
              </MDTypography>
            </MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  control={control1}
                  name="name"
                  render={({ field: { onChange, value } }) => (
                    <MDInput onChange={onChange} value={value || ''} label="Nombre" variant="standard" fullWidth />
                  )}
                />
                {errors1.name && <MDTypography variant="button" color="error">{errors1.name?.message}</MDTypography>}
              </Grid>
            </Grid>
            <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }} pt={5}>
              <MDButton variant="gradient" type="submit" color="info" disabled={isSubmitting1}>
                {isSubmitting1 ? <CircularProgress size={18} color="white" /> : 'Guardar'}
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox pb={3}>
        <Card sx={{ boxShadow: "none" }} >
          <MDBox p={3} component="form" role="form" onSubmit={handleSubmit2(onSubmit2)}>
            <MDBox pb={2}>
              <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                Cambiar Contraseña
              </MDTypography>
            </MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  control={control2}
                  name="current_password"
                  render={({ field: { onChange, value } }) => (
                    <MDInput onChange={onChange} value={value || ''} label="Contraseña Actual" fullWidth />
                  )}
                />
                {errors2.current_password && <MDTypography variant="button" color="error">{errors2.current_password?.message}</MDTypography>}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control2}
                  name="password"
                  render={({ field: { onChange, value } }) => (
                    <MDInput onChange={onChange} value={value || ''} label="Nueva Contraseña" fullWidth />
                  )}
                />
                {errors2.password && <MDTypography variant="button" color="error">{errors2.password?.message}</MDTypography>}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control2}
                  name="password_confirmation"
                  render={({ field: { onChange, value } }) => (
                    <MDInput onChange={onChange} value={value || ''} label="Confirmar Contraseña" fullWidth />
                  )}
                />
                {errors2.password_confirmation && <MDTypography variant="button" color="error">{errors2.password_confirmation?.message}</MDTypography>}
              </Grid>
            </Grid>
            <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }} pt={5}>
              <MDButton variant="gradient" type="submit" color="info" disabled={isSubmitting2}>
                {isSubmitting2 ? <CircularProgress size={18} color="white" /> : 'Guardar'}
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
  );
}

